// Sammel-Einstieg — Widget-Auto-Instanziierung folgt ab Task 4
import { TaupunktWidget } from "./widgets/taupunkt-widget.js";
import { VenturiWidget } from "./widgets/venturi-widget.js";
import { SunWidget } from "./widgets/sun-widget.js";

const boot = (selector, Klass) =>
  document.querySelectorAll(selector).forEach(el => new Klass(el));

boot('[data-widget="taupunkt"]', TaupunktWidget);
boot('[data-widget="venturi"]', VenturiWidget);
boot('[data-widget="sun"]', SunWidget);
